import { render } from "./employeeData.vue?vue&type=template&id=fb6dff4e&scoped=true"
import script from "./employeeData.vue?vue&type=script&lang=js"
export * from "./employeeData.vue?vue&type=script&lang=js"

import "./employeeData.vue?vue&type=style&index=0&id=fb6dff4e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6dff4e"]])

export default __exports__